import React from 'react';
import { BrowserRouter as Router, Link, Routes, Route } from 'react-router-dom';
import VisualzChat from './VisualzChat';
import ChatApp from './ChatApp';
import Soundboard from './Soundboard';
import LandindPage from './LandingPage';
import { Nav, Navbar, Container } from "react-bootstrap";
import './App.css';

export const NaviBar = () => {
  return (
    <Router>

      <Navbar expand="lg" className="fixed-top">
        <Container>
          <Navbar.Brand href="/#">Savupiippu-Ukko</Navbar.Brand>
          <Nav className="ms-auto">
            {/*<Nav.Link to="/VisualzChat" as={Link} style={{ color: "#000", fontSize: "1.2em" }}>Vote</Nav.Link>*/}
            <Nav.Link to="/chat" as={Link} style={{ color: "#000", fontSize: "1.2em" }}>Chat</Nav.Link>
            {/*<Nav.Link to="/Soundboard" as={Link} style={{ color: "#000", fontSize: "1.2em" }}>Soundboard</Nav.Link>*/}
          </Nav>
        </Container>
      </Navbar>

      <Container className="mt-3">
        <Routes>
          <Route path="/" element={<LandindPage/>}></Route>
          <Route path="/VisualzChat" element={<VisualzChat/>}></Route>
          <Route path="/chat" element={<ChatApp/>}></Route>
          <Route path="/Soundboard" element={<Soundboard/>}></Route>
        </Routes>
      </Container>
      
    </Router>
  );
}

export default NaviBar;